import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/components/feature/AdminAuthContext';
import type { ReactNode } from 'react';

export default function AdminGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-10 h-10 mx-auto flex items-center justify-center">
            <i className="ri-loader-4-line animate-spin text-2xl text-primary-500"></i>
          </div>
          <p className="text-sm text-foreground-500 mt-3">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}